import React, { useContext, useEffect } from "react";
import CategoryHome from "../../Components/Categories/CategoryHome";
import { SearchContext, KBContext, AutherContext } from "../../Context";
import ArticleSearch from "../../Components/ArticleSearch/ArticleSearch";
import LegacyArticleSearch from "../../Components/Legacy/LegacyArticleSearch";
import Layout from "../../Components/Layout";
import LegacyLayout from "../../Components/Legacy/LegacyLayout";
import LegacyCategoryHome from "../../Components/Legacy/LegacyCategoryHome";
import { CategoryLoader } from "../../Components/Loaders/CategoryLoader";
import { handleGainSightEventForPageNotFound } from "../../gainSightIntegration";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { isFeatureEnabled } from "../../utils";
import { FTR_KB_NEW_UI } from "../../Constants";

export default function Categories() {
  const navigate = useNavigateWithSearch();
  const { searchList, searchInput } = useContext(SearchContext);
  const { data, availableFeatures } = useContext(KBContext);
  const { isInternal } = data;
  const { redirectToken, hasPermission } = useContext(AutherContext);

  const isNewUI = isFeatureEnabled(FTR_KB_NEW_UI, availableFeatures);

  const showCategories = () => {
    if (isInternal !== undefined && !isInternal) {
      return true;
    } else {
      return hasPermission;
    }
  }

  useEffect(() => {
    if (!data) {
      handleGainSightEventForPageNotFound(window.location.href);
      navigate("/not-found");
    }
  }, [data, navigate]);

  useEffect(() => {
    if (!redirectToken && isInternal && !hasPermission) {
      localStorage.clear();
      navigate("/login");
    }
  }, [isInternal, hasPermission, redirectToken, navigate]);

  if (showCategories() && Object.keys(data).length > 0) {
    const LayoutComponent = isNewUI ? Layout : LegacyLayout;
    const CategoryHomeComponent = isNewUI ? CategoryHome : LegacyCategoryHome;
    const ArticleSearchComponent = isNewUI ? ArticleSearch : LegacyArticleSearch;

    return (
      <>
        <LayoutComponent>
          {searchInput?.length > 0 && searchList ? (
            <ArticleSearchComponent />
          ) : (
            <CategoryHomeComponent />
          )}
        </LayoutComponent>
      </>
    );
  } else {
    return <CategoryLoader />;
  }
}
